import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Providers } from "./components/provider/Providers";
import { Layout } from "./components/layout";
import { ErrorBoundary } from "./components/layout/ErrorBoundary";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/",
    element: <Providers />,
    children: [
      {
        path: "",
        element: <Layout />,
        errorElement: <ErrorBoundary />,
        children: [
          {
            index: true,
            async lazy() {
              const { NewHome } = await import("./page/home");
              return { Component: NewHome };
            },
          },
          {
            path: "",
            async lazy() {
              const { KYCProvider } = await import(
                "./components/provider/KYCProvider"
              );
              return { Component: KYCProvider };
            },
            children: [
              {
                path: "",
                async lazy() {
                  const { loader } = await import(
                    "./components/provider/AuthGuard"
                  );
                  return { loader: loader };
                },
                children: [
                  {
                    path: "bank_transfer_instruction",
                    async lazy() {
                      const [{ BankTransferInstruction }, { loader }] =
                        await Promise.all([
                          import("./page/BankTransferInstruction"),
                          import("./page/BankTransferInstruction/loader"),
                        ]);
                      return { Component: BankTransferInstruction, loader };
                    },
                  },
                  {
                    path: "kyc",
                    async lazy() {
                      const { KYC } = await import("./page/KYC");
                      return { Component: KYC };
                    },
                  },
                  {
                    path: "orders/:id/pay",
                    async lazy() {
                      const { OrderPay } = await import("./page/OrderPay");
                      return { Component: OrderPay };
                    },
                  },
                  {
                    path: "orders",
                    async lazy() {
                      const { Orders } = await import("./page/order/Orders");
                      return { Component: Orders };
                    },
                  },
                  {
                    path: "orders/:id",
                    async lazy() {
                      const { Order } = await import("./page/order/Order");
                      return { Component: Order };
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "auth",
            async lazy() {
              const { Auth } = await import("./page/auth");
              return { Component: Auth };
            },
          },
          // {
          //   path: "auth/email",
          //   async lazy() {
          //     const { AuthWithEmail } = await import("./page/auth/Email");
          //     return { Component: AuthWithEmail };
          //   },
          // },
        ],
      },
      {
        path: "onramp",
        async lazy() {
          const { OnrampPage } = await import("./page/onramp");
          return { Component: OnrampPage };
        },
      },
    ],
  },
]);

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
